// extracted by mini-css-extract-plugin
export default {"wordViewerWrapper":"WordDocumentViewer_wordViewerWrapper__s2ptz","toolbar":"WordDocumentViewer_toolbar__kkm1G","fileTitle":"WordDocumentViewer_fileTitle__zDqJ7"};